import React from "react";
import { bowlingCenterWebsiteHref } from "../TournamentLocations/BowlingCenterInfo";
import {
  bowlingCenterCityLine,
  bowlingCenterMapsHref,
  bowlingCenterStreetLine,
} from "../../utility/organizationBowlingCenters";

const actionClass =
  "text-sm font-medium text-brand-gold-ink hover:underline";

const HouseCard = ({ center }) => {
  if (!center) return null;

  const cityLine = bowlingCenterCityLine(center);
  const streetLine = bowlingCenterStreetLine(center);
  const mapsHref = bowlingCenterMapsHref(center);
  const websiteHref = bowlingCenterWebsiteHref(center.website);
  const phoneDigits = (center.phone || "").replace(/\D/g, "");
  const actions = [
    mapsHref ? (
      <a
        key="directions"
        href={mapsHref}
        target="_blank"
        rel="noopener noreferrer"
        className={actionClass}
      >
        Directions
      </a>
    ) : null,
    center.phone ? (
      <a key="call" href={`tel:${phoneDigits}`} className={actionClass}>
        Call
      </a>
    ) : null,
    websiteHref ? (
      <a
        key="web"
        href={websiteHref}
        target="_blank"
        rel="noopener noreferrer"
        className={actionClass}
      >
        Website
      </a>
    ) : null,
  ].filter(Boolean);

  return (
    <div className="card-board p-4 h-full">
      <p className="font-display font-bold text-brand-charcoal">
        {center.centerName}
      </p>
      {cityLine ? (
        <p className="text-sm text-brand-charcoal mt-0.5">{cityLine}</p>
      ) : null}
      {streetLine && streetLine !== cityLine ? (
        <p className="text-sm text-brand-muted mt-0.5">{streetLine}</p>
      ) : null}
      {actions.length ? (
        <p className="mt-3 flex flex-wrap gap-x-4 gap-y-1">{actions}</p>
      ) : null}
    </div>
  );
};

const TournamentLocations = ({ tournamentLocations }) => {
  if (!tournamentLocations || tournamentLocations.length === 0) {
    return null;
  }

  return (
    <div className="card-board p-6">
      <h2 className="heading-display text-xl mb-3">Houses</h2>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(16rem,1fr))] gap-3">
        {tournamentLocations.map((location) => (
          <HouseCard key={location.id} center={location.bowlingCenters} />
        ))}
      </div>
    </div>
  );
};

export default TournamentLocations;
